/** Shown across a title that is set up but not switched on (outside SECTION_AGENT_PUBS). */
export function SwitchedOffNotice({ section }: { section: string }) {
  return (
    <p role="status" className="mb-6 rounded-[10px] border border-ink-500 bg-ink-700 px-4 py-3 font-ui text-[14px] text-paper-dim">
      <strong className="font-semibold text-paper">Not switched on yet. Read only.</strong>{' '}
      {section} is set up, but nothing can be written or published for it until an administrator switches it on when the title moves over.
    </p>
  )
}
